export default {
  mounted: function mounted() {
    this.checkSize();
    window.addEventListener('resize', this.checkSize);
  },
  methods: {
    checkSize: function checkSize() {
      if (window.innerWidth >= 1024) {
        return;
      }

      var vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
    }
  }
};